'use client'

import Script from 'next/script'
import { useEffect } from 'react'

export default function CalendlyInline() {
  useEffect(() => {
    const href = 'https://assets.calendly.com/assets/external/widget.css'
    if (!document.querySelector(`link[href="${href}"]`)) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = href
      document.head.appendChild(link)
    }
  }, [])

  return (
    <>
      <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/infiteq/30min?hide_gdpr_banner=1"
        style={{ minWidth: 320, height: 700 }}
      />
      <Script
        src="https://assets.calendly.com/assets/external/widget.js"
        strategy="lazyOnload"
      />
    </>
  )
}
